/**
 * 시세공간 시스템 계정(시세공간봇) UUID
 * — 백엔드 `constants/points.ts` 의 SYSTEM_ACCOUNT_ID 와 동기화
 * — 자동 수집 글(코인시황 급등감지, 공시/뉴스 DART) 의 user_id
 */
export const SYSTEM_ACCOUNT_ID = '00000000-0000-0000-0000-000000000001';

export function isSystemAccount(userId?: string | null): boolean {
  return !!userId && userId === SYSTEM_ACCOUNT_ID;
}
